import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { resetAllSteps } from 'actions/stages';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import GeneralContactInfo from 'components/GeneralContactInfo';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import styles from 'pages/NotFound/NotFound.module.scss';

const NotFoundContact = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader
        title="Something went wrong. Please try again later."
        subtitle="If you continue to experience problems, please contact HFS."
        percent={ProgressBarStatus.Warning}
      />
      <FormBody>
        <div className={styles.info_container}>
          <GeneralContactInfo />
        </div>
      </FormBody>
    </>
  );
};

export default NotFoundContact;
